import { render, staticRenderFns } from "./todayPending.vue?vue&type=template&id=395a3eaa&scoped=true&"
import script from "./todayPending.vue?vue&type=script&lang=js&"
export * from "./todayPending.vue?vue&type=script&lang=js&"
import style0 from "./todayPending.vue?vue&type=style&index=0&id=395a3eaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395a3eaa",
  null
  
)

export default component.exports